import { render, staticRenderFns } from "./index.vue?vue&type=template&id=604e10a3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e10a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/9861699c-84a1-47cb-99a1-a59de1c49b16/workspace/streffy-middle-office_pMRG/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604e10a3')) {
      api.createRecord('604e10a3', component.options)
    } else {
      api.reload('604e10a3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=604e10a3&scoped=true", function () {
      api.rerender('604e10a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cus-copy-btn/index.vue"
export default component.exports